// Filename: public/manageFooter.js

import wixWindow from 'wix-window';
import { saveCleverTapEvent } from 'public/cleverTapEvents.js';

export async function footerBtnClicks() {
    $w('#footerSubscribe').onClick((event) => {
        openSubscribeToNewsletterLightBox();
    });
}

export function openSubscribeToNewsletterLightBox() {
    //wixWindow.openLightbox("Subscribe To Newsletter", { saveCTAction: saveCTAction });
    wixWindow.openLightbox("Subscribe", { saveCTAction: saveCTAction });
}

export function saveCTAction(eventName, eventData) {
    saveCleverTapEvent(eventName, eventData);
}